import React from "react";
import { connect } from "react-redux";
import "./style.scss";
import img from "./../../../assets/images/taylor1.jpg";
import {
  Share,
  Send,
  Instagram,
  Favorite,
  Download,
  HeartBroken,
  YouTube,
} from "@mui/icons-material";
function AlbumCard({ title, subTitle, imgUrl, style }) {
  return (
    <figure class="effect-terry" style={{ ...style }}>
      <img src={!!imgUrl ? imgUrl : img} alt="img16" />
      <figcaption>
        <h2>
          {!!title ? title : "Title"}{" "}
          <span>{!!subTitle ? subTitle : "subtitle"}</span>
        </h2>
        <p className="effect-terry__links">
          <a href="#">
            <Download color="white" />
          </a>
          <a href="#">
            <HeartBroken />
          </a>
          <a href="#">
            <Share color="white" />
          </a>
          <a href="#">
            <Instagram color="white" />
          </a>
          <a href="#">
            <YouTube sx={{ color: "red" }} />
          </a>
        </p>
      </figcaption>
    </figure>
  );
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};
export default connect(null, mapDispatchToProps)(AlbumCard);
